import { useAjax, useMzMutation } from "@bsm/component";

export const useValidateDayOffMutation = () => {
    const ajax = useAjax();
    return useMzMutation(async (id: number) =>
        ajax.send({
            type: "POST",
            content_type: "application/json",
            url: `project/dayoff/${id}/validate`,
            data: {},
        })
    );
};